import CareersJobForm from "@components/BasicComponents/Forms/CareersJobForm/CareersJobForm"
import ContainerWrapper from "@components/BasicComponents/Wrappers/ContainerWrapper/ContainerWrapper"
import Separator from "@components/CustomTypography/Separator/Separator"
import Typography, {
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {CategoryModuleType} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React from "react"

import styles from "./OpenApplicationFormSection.module.scss"

type Props = {
	categories: CategoryModuleType[]
}

const OpenApplicationFormSection = (props: Props) => {
	return (
		<ContainerWrapper>
			<div className={styles.formContainer}>
				<Typography
					variant={Variant.Title}
					content={"Apply for this position"}
				/>
				<Separator />
				<CareersJobForm
					categories={props.categories}
					location={""}
					position={"open application"}
				/>
			</div>
			<Separator size={128} />
		</ContainerWrapper>
	)
}

export default OpenApplicationFormSection
